/* テンプレート表示画面 */
import React, { useState, useEffect, useCallback } from 'react';
import { handleBrowzerBack } from '../BrowzerBack';
import Text from '../molecules/Text';
import axios from '../axios';
import Moment from 'moment';
import ShelfInShelf from '../molecules/ShelfInShelf';
import Shelf from '../molecules/Shelf';
import {
  ParentShelf,
  ChildShelf,
  Content,
  FormResponse,
  DialogState,
  PostData,
  DialogRespose,
  ResponsData,
  SearchResult,
  SearchDialogState,
  TextWithSearchDialogState,
  AutoInput,
} from '../types/Template';
import RowDate from '../molecules/RowDate';
import Postcode from '../molecules/Postcode';
import Telnum from '../molecules/TelInput';
import NameInput from '../molecules/NameInput';
import RadioButton from '../molecules/RadioButton';
import CheckBox from '../molecules/CheckBox';
import Select from '../molecules/Select';
import TopArea from '../molecules/TopArea';
import TextArea from '../molecules/TextArea';
import Paragraph from '../molecules/Paragraph';
import EnclosedString from '../molecules/EnclosedString';
import LayoutDivision from '../molecules/LayoutDivision';
import YearMonth from '../molecules/InputYearMonth';
import Image from '../molecules/Image';
import RowFullJustifyButton from '../molecules/RowFullJustifyButton';
import RowJustifyButton from '../molecules/RowJustifyButton';
import RowLeftButton from '../molecules/RowLeftButton';
import RowRightButton from '../molecules/RowRightButton';
import RowCenterButton from '../molecules/RowCenterButton';
import FileUploadTemplate from '../organisms/FileUpload';
import FloatingMenu from '../organisms/FloatingMenu';
import { FileUpload } from '../types/FileUpload';
import FooterButtonShelf from '../molecules/FooterAreaButtons';
import ResponseDialog from '../molecules/ResponseDialog';
import TextWithSearchDialog from '../molecules/TextWithSearchDialog';
import BusinessDayCalendar from '../organisms/BusinessDayCalendar';
import NoLabelTextarea from '../molecules/NoLabelTextarea';
import NoLabelCheckBox from '../molecules/NoLabelCheckBox';
import ShelfHeading from '../molecules/ShelfHeading';
import Clause from '../molecules/Clause';
import CenterParagraph from '../molecules/CenterParagraph';
import {
  tmp_init,
  api_response_type,
  convert_types,
  dialog_init,
  dialog_type,
  dialog_function,
  shelf_type,
  fm_types,
  scroll_option,
  download_wait_time,
  loding_close_timmer,
  content_type,
  valid_merge_index,
  postcode_index,
  search_dialog_init,
  item_init,
  text_with_search_dialog_init,
  address_option,
  text_with_search_option,
  address_init,
} from '../Const';
import { convertData, removeComma } from '../Convert';
import { isBrowserIe } from '../BrowserJudgment';
import { scrollTargetElement } from '../Scroll';
import LoadingModal from '../molecules/LoadingModal';
import { fileDownload } from '../FileDownload';
import { editModalBody } from '../EditModal';
import { genUniqueId, jumpUrl } from './../Common';
import { isBrowserIOSSafari, isBrowserIpadSafari } from '../BrowserJudgment';
import { releaseBrowzerBack } from '../BrowzerBack';
import SearchResultDialog from '../molecules/SearchResultDialog';
import RowLeftAndRightAlignmentButton from '../molecules/RowLeftAndRightAlignmentButton';
import RowLeftAndCenterAlignmentButton from '../molecules/RowLeftAndCenterAlignmentButton';
import { createRoot } from 'react-dom/client';
import TextWithSearch from '../molecules/TextWithSearch';
import { KeyValue } from '../types/KeyValue';
import useDialog from '../hooks/useDialog';
import UserInfoSubmitReception from '../organisms/UserInfoSubmitReception';
import ReceptionActions from '../organisms/ReceptionActions';

const Reception: React.FC = () => {
  // 親棚の状態
  const [parent_shelfs, setParentShelfs] = useState<ParentShelf[]>([]);
  // 子棚の状態
  const [child_shelfs, setChildShelfs] = useState<ChildShelf[]>([]);
  // 小棚内要素の状態
  const [contents, setContents] = useState<Content[]>([]);
  const [upload_token, setUploadToken] = useState<string>('');
  // ヘッダーに表示する情報
  const [reception_cd, setReceptionCd] = useState('');
  const [reception_sub_cd, setReceptionSubCd] = useState('');
  const [status, setStatus] = useState('');
  const [status_code, setStatusCode] = useState(0);
  const [email, setEmail] = useState('');
  const [is_staff, setIsStaff] = useState(false);
  const [reception_id, setReceptionId] = useState(0);
  const [application_date, setApplicationDate] = useState('');
  const [application_product, setApplicationProduct] = useState('');
  const [user_name, setUserName] = useState('');
  const [user_kana_name, setUserKanaName] = useState('');
  const [mypage_status_opened, setMypageStatusOpened] = useState(false);
  const [message, setMessage] = useState('');
  const [ident_lv1_cd, setIdentLv1Cd] = useState('');
  const [ident_lv2_cd, setIdentLv2Cd] = useState('');
  const [ident_lv3_cd, setIdentLv3Cd] = useState('');
  const [desired_amount_before, setDesiredAmountBefore] = useState('');
  const [desired_amount_application, setDesiredApplication] = useState('');
  const [desired_amount_after, setDesiredAmountAfter] = useState('');

  // 提出済み本人確認書類リスト
  const [file_upload_list, setFileUploadList] = useState<FileUpload[]>([]);
  // 返答ダイアログ状態
  const [response_dialog_state, setResponseDialogState] = useState<DialogState>(dialog_init);
  // 検索ダイアログ状態
  const [search_dialog_state, setSearchDialogState] =
    useState<SearchDialogState>(search_dialog_init);
  // 検索項目つきテキストボックスダイアログ状態
  const [text_with_search_dialog_state, setTextWithSearchDialogState] =
    useState<TextWithSearchDialogState>(text_with_search_dialog_init);
  // 住所選択状態
  const [address_state, setAddressState] = useState(address_init);
  // 検索項目つきテキストボックスの項目選択状態
  const [text_with_search_state, setTextWithSearchState] = useState(item_init);
  // Ajax通信状態
  const [is_connecting, setIsConnecting] = useState(false);
  // ローディング画面表示状態
  const [is_loading, setIsLoading] = useState(false);
  // onChange発火フラグ
  const [is_on_change, setIsOnChange] = useState(false);

  const [isEditMode, setIsEditMode] = useState(false);

  const [resDataTemplate, setResDataTemplate] = useState<any>();

  const [isClickConfirm, setIsClickConfirm] = useState(false);
  const isConfirmMode = (() => {
    const firstSegmentPath = window?.location?.pathname?.split('/')?.[1];
    return firstSegmentPath === 'receptions-confirm';
  })();

  const disableAllContents = (contents: Content[]) => {
    return contents?.reduce<Content[]>((prev, curr) => [...prev, { ...curr, disabled: true }], []);
  };

  const branchValue = contents?.find((content) => content.field_column_name === 'branch')?.value;
  const emailValue = contents?.find((content) => content.field_column_name === 'email')?.value;

  /**
   * テンプレート取得用のパスを生成する
   *
   * Note: 現在のURLからAPI取得用のURLを作成します。
   * 使用URLの変更等があった場合は修正必須です。
   * URL末尾 ⇒ reception_id 案件ID
   * URL末尾-1 ⇒ reception_cd 案件CD
   *
   * @return string テンプレート取得URL
   */
  const makePath = (): string => {
    return isConfirmMode
      ? `api/receptions/confirm/${getKeyFormUrl()}`
      : `api/receptions/${getKeyFormUrl()}`;
  };

  const getKeyFormUrl = () => {
    const urls = location.pathname.split('/');
    return urls.pop();
  };

  const getTabId = () => sessionStorage.getItem('tab_id') || '';

  /**
   * アップロード済みファイル取得用APIのパスを生成する
   *
   * @param {string} tabId - タブ識別ID
   * @return {string} ファイル取得APIのURL
   */
  const makePathFileUpload = (tab_id: string): string => {
    const urls = location.pathname.split('/');
    const key = urls.pop(); // template_id

    return `api/receptions/confirm/${key}/file?tab_id=${tab_id}`;
  };

  const setupSessionHeaders = () => {
    if (sessionStorage.getItem('tab_id') && !window.name) {
      sessionStorage.removeItem('tab_id');
    }

    if (!sessionStorage.getItem('tab_id')) {
      const uniqueId = 'tab_' + genUniqueId();
      sessionStorage.setItem('tab_id', uniqueId);
      window.name = uniqueId;
    }
  };

  useEffect(() => {
    setupSessionHeaders();
    // ブラウザの戻る・進む禁止
    handleBrowzerBack();
    fetchReception(makePath());
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (isConfirmMode || isClickConfirm) return;
      event.preventDefault();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isConfirmMode, isClickConfirm]);

  /**
   * 案件詳細画面表示に必要なデータを再取得します。
   * エラー発生時はローディングを非表示にします。
   * @param url データ取得先url
   */
  const fetchReception = async (url: string) => {
    const params = new URLSearchParams();
    const tabId = getTabId();
    if (tabId) {
      params.append('tab_id', tabId);
    }

    const queryString = params.toString();
    const newUrl = queryString ? `${url}?${queryString}` : url;

    try {
      const response = await axios.get(newUrl);
      setResDataTemplate(response?.data);
      setParentShelfs(response.data.info.parent_blocks);
      setChildShelfs(response.data.info.child_blocks);
      const contentWithUserSubmit: Content[] = [
        ...response.data.info.contents,
        ...(!isConfirmMode &&
        !response?.data?.info?.contents?.some((content: Content) =>
          ['email', 'branch'].includes(content?.key)
        )
          ? [
              { key: 'email', field_column_name: 'email', value: response?.data?.user_info?.email },
              {
                key: 'branch',
                field_column_name: 'branch',
                hidden: !response?.data?.template?.has_branch,
              },
            ]
          : []),
      ];
      setContents(
        isConfirmMode ? disableAllContents(contentWithUserSubmit) : contentWithUserSubmit
      );
      setMypageStatusOpened(response.data.info.mypage_status_opened);
      setFileUploadList(response.data.info.files);
      getPreview(response.data.info.files, tabId);
      setUploadToken(response.data.upload_token);
      sessionStorage.setItem('upload_token', response.data.upload_token);
      setIsEditMode(response.data.is_edit_mode);
    } catch (error) {
      const errorData = error?.response?.data;

      if (errorData?.error_code === 'SESSION_EXPIRED') {
        handleTemporaryFilesCleanup();
      }
      // エラーメッセージを表示後、案件一覧に遷移する
      alert(errorData?.message);
      location.replace(
        `${location.origin}${process.env.MIX_MOCK_URL}/receptions/${getKeyFormUrl()}`
      );
    }
  };

  const handleTemporaryFilesCleanup = async () => {
    const savedToken = sessionStorage.getItem('upload_token');

    if (!savedToken) return;

    try {
      await axios.post(`/api/receptions/cleanup-files`, {
        upload_token: savedToken,
      });

      // クリーンアップ成功後、ストレージからトークンを削除
      sessionStorage.removeItem('upload_token');
    } catch (clearError) {
      console.error('Failed to cleanup temporary files:', clearError);
    }
  };

  /**
   * プレビュー表示する画像を非同期で取得する
   *
   * @param {Array<FileUpload>} file_upload_list ファイル情報
   */
  const getPreview = async (file_upload_list: Array<FileUpload>, tab_id: string) => {
    // 画像情報取得データ作成
    const array = file_upload_list.map((data: FileUpload) => {
      return data.file_upload_name;
    });
    const response = await axios.post(makePathFileUpload(tab_id), array);
    // 取得結果を格納
    const result_array = file_upload_list.map((data: FileUpload, index: number) => {
      return {
        ...data,
        preview_file_src: response.data[index],
      };
    });
    setFileUploadList(result_array);
  };

  /**
   * 親の棚を作成
   * Note: 棚種別は 2, 3, 4以外不要
   * @return JSX.Element[]
   */
  const createParentBlock = () => {
    // 初期表示用条件
    return parent_shelfs.map((parent_shelf) => {
      switch (parent_shelf.pb_kind) {
        case shelf_type.shelf: // アコーディオン出力
          return (
            <Shelf
              key={parent_shelf.pb_id}
              label={parent_shelf.pb_display_name}
              is_open={parent_shelf.pb_open}
              handleClick={() => toggleParentShelf(parent_shelf.pb_id)}
            >
              {createChildBlock(parent_shelf.pb_id)}
            </Shelf>
          );
        case shelf_type.layout_divisiton: // レイアウト用論理棚
          return (
            <LayoutDivision key={parent_shelf.pb_id}>
              {createChildBlock(parent_shelf.pb_id)}
            </LayoutDivision>
          );
        case shelf_type.fragment: // domを出力しない棚
          return (
            <React.Fragment key={parent_shelf.pb_id}>
              {createChildBlock(parent_shelf.pb_id)}
            </React.Fragment>
          );
        default:
          return;
      }
    });
  };

  /**
   * 親棚を開閉する
   *
   * @param parent_id 親棚のid
   */
  const toggleParentShelf = (parent_id: number) => {
    setParentShelfs((prev) => {
      // 対象親棚のindex取得
      const current_index = prev.findIndex((value) => value.pb_id === parent_id);
      // ディープコピー
      const array = prev.slice();
      array[current_index].pb_open = !prev[current_index].pb_open;
      return array;
    });
  };

  /**
   * 子の棚を作成
   * @param parent_id 親棚のid
   * @return JSX.Element[]
   */
  const createChildBlock = (parent_id: number) => {
    /** 口座区分の情報 */
    const account_type_param = contents.find((it) => {
      return it.fm_type === fm_types.account_type;
    });

    return child_shelfs.map((child_shelf) => {
      if (parent_id !== child_shelf.pb_id) {
        return;
      }
      switch (child_shelf.cb_kind) {
        case shelf_type.header: // ヘッダー01
          return (
            <TopArea
              key={child_shelf.key}
              reception_cd={reception_cd}
              is_staff={is_staff}
              status_name={status}
              email={email}
              application_date={application_date}
              application_product={application_product}
              user_name={user_name}
              user_kana_name={user_kana_name}
              status_code={status_code}
              receptionHitsoryCallback={(event) => clickReceptionHistory(event)}
              is_history={false}
              message={message}
              desired_amount_before={desired_amount_before}
              desired_amount_application={desired_amount_application}
              desired_amount_after={desired_amount_after}
            />
          );
        case shelf_type.shelf: // アコーディオン出力
        case shelf_type.account_transfer_info: // 口座振替情報
        case shelf_type.bank_account: // 銀行口座
        case shelf_type.ja_bank: // ゆうちょ銀行
        case shelf_type.customer_upload: // お客様アップロード
          return (
            <ShelfInShelf
              key={child_shelf.key}
              id={child_shelf.key}
              label={child_shelf.cb_display_name}
              is_open={child_shelf.cb_open}
              handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
            >
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </ShelfInShelf>
          );
        case shelf_type.account_holder: // 口座名義人
          if (account_type_param?.value !== '1') {
            // 口座振替情報 口座区分 が「既存」以外の場合表示する
            return (
              <ShelfInShelf
                key={child_shelf.key}
                id={child_shelf.key}
                label={child_shelf.cb_display_name}
                is_open={child_shelf.cb_open}
                handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
              >
                {createContents(child_shelf.pb_id, child_shelf.cb_id)}
              </ShelfInShelf>
            );
          }
          break;
        case shelf_type.layout_divisiton: // レイアウト用論理棚
          return (
            <LayoutDivision key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </LayoutDivision>
          );
        case shelf_type.fragment: // domを出力しない棚
          return (
            <React.Fragment key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </React.Fragment>
          );
        case shelf_type.footer: // 案件一覧に戻るボタン表示
          // マイページ未開設時は非表示
          // 変更があった場合のみダイアログを開く
          return (
            mypage_status_opened && (
              <FooterButtonShelf
                key={child_shelf.key}
                is_staff={is_staff}
                is_on_change={is_on_change}
              />
            )
          );
        case shelf_type.full_justify_buttons: // ボタン左右中央寄せ
          return (
            <RowFullJustifyButton key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </RowFullJustifyButton>
          );
        case shelf_type.left_button: // ボタン左寄せ
          return (
            <RowLeftButton key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </RowLeftButton>
          );
        case shelf_type.center_button: // ボタン中央寄せ
          return (
            <RowCenterButton key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </RowCenterButton>
          );
        case shelf_type.right_button: // ボタン右寄せ
          return (
            <RowRightButton key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </RowRightButton>
          );
        case shelf_type.justify_buttons: // ボタン均等割付
          return (
            <RowJustifyButton key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </RowJustifyButton>
          );
        case shelf_type.left_and_right_alignment_buttons: // ボタン左右揃え
          return (
            <RowLeftAndRightAlignmentButton key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </RowLeftAndRightAlignmentButton>
          );
        case shelf_type.left_and_center_alignment_buttons: // ボタン左中央配置
          return (
            <RowLeftAndCenterAlignmentButton key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </RowLeftAndCenterAlignmentButton>
          );
        default:
          return;
      }
    });
  };

  /**
   * 子棚を開閉する
   *
   * @param parent_id 親棚のid
   * @param child_id 子棚のid
   * @param is_open 開閉フラグ（true:開,false:閉）
   */
  const toggleChildShelf = (parent_id: number, child_id: number, is_open?: boolean) => {
    setChildShelfs((prev) => {
      // 対象子棚のindex取得
      const current_index = prev.findIndex(
        (value) => value.pb_id === parent_id && value.cb_id === child_id
      );
      // 対象子棚の開閉状態を設定
      const cb_open = typeof is_open === 'undefined' ? !prev[current_index].cb_open : is_open;
      // ディープコピー
      const array = prev.slice();
      array[current_index].cb_open = cb_open;
      return array;
    });
  };

  /**
   * 次の小棚を見つける
   * 同じ親棚に所属していない場合, 次の棚が無い場合は0を返す
   *
   * @param cb_id 小棚のid
   */
  const findNextChidShelf = (cb_id: number) => {
    const current_index = child_shelfs.findIndex((child_shelf) => child_shelf.cb_id === cb_id);
    const next_index = child_shelfs.findIndex((child_shelf) => child_shelf.cb_id === cb_id) + 1;
    if (
      typeof child_shelfs[current_index] !== 'undefined' &&
      typeof child_shelfs[next_index] !== 'undefined' &&
      child_shelfs[current_index].pb_id === child_shelfs[next_index].pb_id
    ) {
      return child_shelfs[next_index].cb_id;
    } else {
      return 0;
    }
  };

  /**
   * 次の棚へスクロールする
   *
   * @param parent_id 親棚id
   * @param next_child_id 次へボタンを押下した棚のid
   */
  const scrollToNextShelf = (parent_id: number, next_child_id: number) => {
    const current_index = child_shelfs.findIndex(
      (value) => value.pb_id === parent_id && value.cb_id === next_child_id
    );
    const target_shelf_id = child_shelfs[current_index].key;
    const element = document.getElementById(target_shelf_id);
    scrollTargetElement(element, scroll_option.next_shelf);
  };

  /**
   * ボタン押下時にダイアログを表示する
   *
   * @param fm_id フィールドマスタのid
   */
  const toggleDialog = (fm_id: number) => {
    setContents((prev) => {
      const index = prev.findIndex((value) => value.fm_id === fm_id && !value.disabled);
      const array = prev.slice(); // ディープコピー
      array[index].dialog_is_open = !array[index].dialog_is_open;
      return array;
    });
  };

  /**
   * 小の棚内に表示する要素を決定
   * @param pb_id 親の棚のid
   * @param cb_id 子の棚のid
   * @return JSX.Element[]
   */
  const createContents = (pb_id: number, cb_id: number) => {
    const tmp_year: Content[] = [tmp_init];
    const tmp_sei: Content[] = [tmp_init];
    return contents.map((content, index) => {
      if (cb_id !== content.cb_id || pb_id !== content.pb_id) {
        return;
      }
      switch (content.fm_type) {
        case fm_types.text: // テキストボックス表示
        case fm_types.number: // 数字入力欄表示
          return (
            <Text
              key={`${content.key}-${index}`}
              id={content.key}
              fm_id={content.fm_id}
              label={content.fm_display_name}
              placeholder={content.placeholder}
              value={content.value}
              need={content.required_mark}
              message={content.message}
              name={content.field_column_name}
              handleChange={handleChange}
              suffix={content.suffix}
              help_msg={content.help_msg}
              disabled={content.disabled}
              maxlength={content.maxlength}
              handleFocus={() =>
                handleFocus(content.fm_id, content.value, content.input_assistance)
              }
              handleBlur={() => {
                handleBlurCallApi(
                  content.fm_id,
                  content.value,
                  content.input_assistance,
                  content.is_send_parent,
                  content.function,
                  content.pb_id,
                  content.cb_id
                );
              }}
              add_comma={content.input_assistance === convert_types.add_comma ? true : false}
              input_assistance={content.input_assistance}
            />
          );
        case fm_types.date: // Datepicker表示
          return (
            <RowDate
              key={`${content.key}-${index}`}
              id={content.key}
              label={content.fm_display_name}
              need={content.required_mark}
              message={content.message}
              value={
                content.value !== null && content.value !== ''
                  ? new Date(Moment(content.value).format('YYYY/MM/DD'))
                  : null
              }
              name={content.field_column_name}
              placeholder={content.placeholder}
              help_msg={content.help_msg}
              disabled={content.disabled}
              handleChange={(date: Date) => {
                handleChangeInput(date, content.fm_id);
              }}
              handleBlur={() => {
                handleBlurForDate(content, content.value);
              }}
              handleCalendarClose={() => {
                handleBlurForDate(content, content.value);
              }}
              min_date={content.min_date ? new Date(content.min_date) : null}
              max_date={content.max_date ? new Date(content.max_date) : null}
            />
          );
        case fm_types.business_date: // BusinessDayCalendar表示（申込人：借入希望日）
          return (
            <BusinessDayCalendar
              key={`${content.key}-${index}`}
              id={content.key}
              label={content.fm_display_name}
              need={content.required_mark}
              message={content.message}
              value={
                content.value !== null && content.value !== ''
                  ? new Date(Moment(content.value).format('YYYY/MM/DD'))
                  : null
              }
              name={content.field_column_name}
              placeholder={content.placeholder}
              help_msg={content.help_msg}
              disabled={content.disabled}
              handleChange={(date: Date) => {
                handleChangeInput(date, content.fm_id);
              }}
              handleBlur={() => {
                handleBlurForDate(content, content.value);
              }}
              handleCalendarClose={() => {
                handleBlurForDate(content, content.value);
              }}
            />
          );
        case fm_types.button: // ボタン表示
        case fm_types.postcode: // 郵便番号表示
          return (
            <Postcode
              id={content.key}
              key={`${content.key}-${index}`}
              label={content.fm_display_name}
              need={content.required_mark}
              value={content.value}
              clickCallback={() =>
                handleClickSearch(
                  content.function,
                  content.fm_id,
                  content.field_column_name,
                  content.value,
                  content.pb_id,
                  content.cb_id
                )
              }
              handleChangePostCode1={(event: React.ChangeEvent<HTMLInputElement>) => {
                handleChangePostCode(
                  event.target.value,
                  content.fm_id,
                  content.value,
                  postcode_index.first
                );
              }}
              handleChangePostCode2={(event: React.ChangeEvent<HTMLInputElement>) => {
                handleChangePostCode(
                  event.target.value,
                  content.fm_id,
                  content.value,
                  postcode_index.last
                );
              }}
              handleBlurPostCode1={() => {
                handleBlurPostCode(
                  content.fm_id,
                  content.value,
                  content.input_assistance,
                  postcode_index.first
                );
              }}
              handleBlurPostCode2={() => {
                handleBlurPostCode(
                  content.fm_id,
                  content.value,
                  content.input_assistance,
                  postcode_index.last
                );
              }}
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
            />
          );
        case fm_types.text_with_search: // 検索項目つきテキストボックス
          return (
            <TextWithSearch
              id={content.key}
              key={`${content.key}-${index}`}
              label={content.fm_display_name}
              need={content.required_mark}
              value={content.value}
              handleChange={handleChange}
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
              readonly={true}
              clickCallback={() =>
                showTextWithSearchItem(content.sources ?? [], content.field_column_name)
              }
            />
          );
        case fm_types.tel: // 電話番号
          return (
            <Telnum
              key={`${content.key}-${index}`}
              label={content.fm_display_name}
              value={content?.value}
              handleChange={(changeValue) => {
                handleChangeInput(changeValue, content.fm_id);
              }}
              handleBlur={() => {
                validationCheck(content.fm_id, content.value, content.input_assistance);
              }}
              need={content.required_mark}
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
            />
          );
        case fm_types.sei: // 姓
          tmp_sei[index] = content;
          break;
        case fm_types.mei: // 名
          return tmp_sei[index - 1]?.fm_id ? (
            <NameInput
              key={`${content.key}-${index}`}
              first_id={content.key}
              last_id={tmp_sei[index - 1].key}
              label={tmp_sei[index - 1].fm_display_name}
              need={content.required_mark}
              first_name={content.field_column_name}
              last_name={tmp_sei[index - 1].field_column_name}
              first_placeholder={content.placeholder}
              last_placeholder={tmp_sei[index - 1].placeholder}
              first_value={content.value}
              last_value={tmp_sei[index - 1].value}
              first_maxlength={content.maxlength}
              last_maxlength={tmp_sei[index - 1].maxlength}
              first_prefix={content.prefix}
              last_prefix={tmp_sei[index - 1].prefix}
              handleChangeFirstName={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleChangeInput(event.target.value, content.fm_id)
              }
              handleChangeLastName={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleChangeInput(event.target.value, tmp_sei[index - 1].fm_id)
              }
              message={tmp_sei[index - 1].message ?? content.message}
              help_msg={content.help_msg}
              first_disabled={content.disabled}
              last_disabled={tmp_sei[index - 1].disabled}
              handleBlurFirstName={() => {
                handleBlur(content.fm_id, content.value, content.input_assistance);
              }}
              handleBlurLastName={() => {
                handleBlur(
                  tmp_sei[index - 1].fm_id,
                  tmp_sei[index - 1].value,
                  tmp_sei[index - 1].input_assistance
                );
              }}
            />
          ) : null;
        case fm_types.radio: // ラジオボタン
          return (
            <RadioButton
              key={`${content.key}-${index}`}
              id={content.key}
              label={content.fm_display_name}
              need={content.required_mark}
              name={content.key} // Note tani.t 一意になる情報としてkey値を渡す
              value={content.value}
              sources={content.sources ?? []}
              handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleChangeInput(event.target.value, content.fm_id)
              }
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
              handleBlur={() => {
                handleBlur(content.fm_id, content.value, content.input_assistance);
              }}
            />
          );
        case fm_types.checkbox: //チェックボックス
          return (
            <CheckBox
              key={`${content.key}-${index}`}
              id={content.key}
              label={content.fm_display_name}
              need={content.required_mark}
              name={content.field_column_name}
              value={content.value}
              sources={content.sources ?? []}
              handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleChangeCheck(
                  event.target.value,
                  event.target.checked,
                  content.fm_id,
                  content.value
                )
              }
              handleBlur={() => {
                handleBlur(content.fm_id, content.value, content.input_assistance);
              }}
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
            />
          );
        case fm_types.select: // セレクトボックス
          return (
            <Select
              key={`${content.key}-${index}`}
              id={content.key}
              label={content.fm_display_name}
              need={content.required_mark}
              name={content.field_column_name}
              value={content.value}
              sources={content.sources ?? []}
              handleChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                handleChangeInput(event.target.value, content.fm_id);
                handleChangeSelected(event, content);
              }}
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
              suffix={content.suffix}
              handleBlur={() => {
                handleBlur(content.fm_id, content.value, content.input_assistance);
              }}
            />
          );
        case fm_types.textarea: // テキストエリア
          return (
            <TextArea
              id={content.key}
              key={`${content.key}-${index}`}
              fm_id={content.fm_id}
              label={content.fm_display_name}
              need={content.required_mark}
              name={content.field_column_name}
              value={content.value}
              handleChange={handleChange}
              placeholder={content.placeholder}
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
              handleBlur={() => {
                handleBlur(content.fm_id, content.value, content.input_assistance);
              }}
              maxlength={content.maxlength}
            />
          );
        case fm_types.paragraph: // Pタグ文章
          return (
            <Paragraph
              key={`${content.key}-${index}`}
              label={content.fm_display_name}
              color={content.color}
              bold={content.bold}
            />
          );
        case fm_types.center_paragraph: // Pタグ文章（中央表示）
          return (
            <CenterParagraph key={`${content.key}-${index}`} label={content.fm_display_name} />
          );
        case fm_types.paragraph2: // 囲み付き文字列
          return (
            <EnclosedString
              key={`${content.key}-${index}`}
              label={content.fm_display_name}
              color={content.color}
              bold={content.bold}
            />
          );
        case fm_types.year: // 年
          tmp_year[index] = content;
          break;
        case fm_types.month: // 月
          return tmp_year[index - 1]?.fm_id ? (
            <YearMonth
              key={`${content.key}-${index}`}
              year_id={tmp_year[index - 1].key}
              month_id={content.key}
              label={tmp_year[index - 1].fm_display_name}
              need={content.required_mark}
              year_name={tmp_year[index - 1].field_column_name}
              month_name={content.field_column_name}
              year_suffix={tmp_year[index - 1].suffix}
              month_suffix={content.suffix}
              year_placeholder={tmp_year[index - 1].placeholder}
              year={tmp_year[index - 1].value}
              month={content.value}
              year_maxlength={tmp_year[index - 1].maxlength}
              help_msg={tmp_year[index - 1].help_msg}
              year_disabled={tmp_year[index - 1].disabled}
              month_disabled={content.disabled}
              message={tmp_year[index - 1].message ?? content.message}
              handleChangeYear={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleChangeInput(event.target.value, tmp_year[index - 1].fm_id)
              }
              handleChangeMonth={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleChangeInput(event.target.value, content.fm_id)
              }
              handleBlurYear={() => {
                handleBlur(
                  tmp_year[index - 1].fm_id,
                  tmp_year[index - 1].value,
                  tmp_year[index - 1].input_assistance
                );
              }}
              handleBlurMonth={() => {
                handleBlur(content.fm_id, content.value, content.input_assistance);
              }}
              sources={content.sources ?? []}
            />
          ) : null;
        case fm_types.image: // 画像
          return <Image key={`${content.key}-${index}`} value={content.value} />;
        case fm_types.file: // ファイルアップローダ
          return (
            <FileUploadTemplate
              key={`${content.key}-${index}`}
              files_upload={file_upload_list}
              setFilesUpload={setFileUploadList}
              block_disabled={content.disabled}
              fm_id={content.fm_id}
              is_staff={is_staff}
              ident_lv1_cd={ident_lv1_cd}
              ident_lv2_cd={ident_lv2_cd}
              ident_lv3_cd={ident_lv3_cd}
              reception_id={reception_id}
              reception_cd={reception_cd}
              reception_sub_cd={reception_sub_cd}
              upload_token={upload_token}
              need={content.required_mark}
              onUpload={(fileName) => {
                setContents((prev) =>
                  prev.map((item) => {
                    if (item.fm_id !== content.fm_id) return item;

                    const newValue = [...(item.value ? item.value.split('|') : []), fileName].join(
                      '|'
                    );

                    return {
                      ...item,
                      value: newValue,
                    };
                  })
                );
              }}
              onCancel={async (fileName) => {
                const nextContents = contents.map((item) => {
                  if (item.fm_id !== content.fm_id) {
                    return item;
                  }

                  return {
                    ...item,
                    value: item.value
                      ?.split('|')
                      .filter((name: string) => name !== fileName)
                      .join('|'),
                  };
                });

                setContents(nextContents);

                const nextFilesUploadList = file_upload_list.map((f) => {
                  if (f.file_upload_name !== fileName) return f;

                  return {
                    ...f,
                    preview_file_src: '',
                    file_label: '',
                    is_loading: false,
                    is_uploaded: false,
                    file_upload_date: '',
                    file: new Blob(),
                    is_modal_show: false,
                    file_upload_name: '',
                  };
                });

                if (isEditMode) {
                  await saveConfirmData(nextContents, nextFilesUploadList);
                }
              }}
            />
          );
        case fm_types.no_label_textarea: // ラベルなしテキストエリア
          return (
            <NoLabelTextarea
              id={content.key}
              key={`${content.key}-${index}`}
              fm_id={content.fm_id}
              name={content.field_column_name}
              value={content.value}
              handleChange={handleChange}
              placeholder={content.placeholder}
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
              handleBlur={() => {
                handleBlur(content.fm_id, content.value, content.input_assistance);
              }}
              maxlength={content.maxlength}
            />
          );
        case fm_types.no_label_checkbox: // ラベルなしチェックボックス
          return (
            <NoLabelCheckBox
              key={`${content.key}-${index}`}
              id={content.key}
              need={content.required_mark}
              name={content.field_column_name}
              value={content.value}
              sources={content.sources ?? []}
              handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleChangeCheck(
                  event.target.value,
                  event.target.checked,
                  content.fm_id,
                  content.value
                )
              }
              handleBlur={() => {
                handleBlur(content.fm_id, content.value, content.input_assistance);
              }}
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
              fm_id={content.fm_id}
            />
          );
        case fm_types.shelf_heading: // 棚内の見出し
          return <ShelfHeading label={content.fm_display_name} />;
        case fm_types.clause: // 同意文章
          return (
            <Clause
              id_name={`${content.key}-${index}`}
              key={`${content.key}-${index}`}
              label={content.fm_display_name}
              content={content.clause_content ?? ''}
              checked={content.value}
              disabled={content.disabled}
              need={content.required_mark}
              message={content.message}
              help_msg={content.help_msg}
              check_box_title={content.check_box_title}
              onChange={(event) => {
                const checked = event.target.checked;
                setContents((prev) =>
                  prev.map((item) =>
                    item.fm_id === content.fm_id
                      ? {
                          ...item,
                          value: checked,
                        }
                      : item
                  )
                );
              }}
              handleBlur={() => {
                handleBlur(content.fm_id, content.value, content.input_assistance);
              }}
            />
          );
        default:
          break;
      }
    });
  };

  /**
   * 各項目入力値をstateに保存する
   * 対応項目：Text, TextArea
   * Note: 実装としてはこちらがベストな方法。
   * 全コンポーネントのコールバックをこの実装に変更する。
   *
   * @param event チェンジイベント
   */
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      const fm_id = Number(event.currentTarget.dataset.fm_id);
      const event_value = event.target.value;
      setContents((prev) => {
        const index = prev.findIndex((value) => value.fm_id === fm_id && !value.disabled);
        const array = prev.slice(); // ディープコピー
        array[index].value = event_value;
        return array;
      });
      // onChangeイベント発火フラグOn
      setIsOnChange(true);
    },
    [setContents]
  );

  /**
   * 各項目入力値をstateに保存する
   * 対応項目：Name, Text, Number, RadioButton, SELECT, Date, TextArea, YearMonth
   *
   * @param event_value 入力値
   * @param name 対象のname属性
   * @param max_length 最大文字数
   */
  const handleChangeInput = (event_value: string | Date | string[], fm_id: number) => {
    setContents((prev) => {
      const index = prev.findIndex((value) => value.fm_id === fm_id && !value.disabled);
      const array = prev.slice(); // ディープコピー
      // 対象の値を変更
      array[index].value = event_value;

      return array;
    });

    // onChangeイベント発火フラグOn
    setIsOnChange(true);
  };

  /**
   * 項目のフォーカスアウト時の処理
   * @param id 項目ID
   * @param value 項目の入力値
   * @param type 項目の変換タイプ
   */
  const handleBlur = (id: number, value: string, type: string) => {
    // 入力値変換
    const convert_data = convertInputData(id, value, type);
    // バリデーションチェック
    validationCheck(id, convert_data, type);
  };

  /**
   * 項目のフォーカスイン時の処理(カンマ除去)
   * @param fm_id フィールドマスタのid
   * @param input_value 入力値
   * @param type 項目の変換タイプ
   */
  const handleFocus = (fm_id: number, input_value: string, type: string) => {
    setContents((prev) => {
      const index = prev.findIndex((value) => value.fm_id === fm_id && !value.disabled);
      const array = prev.slice(); // ディープコピー
      // 数値変換適用値
      const converted_value = removeComma(input_value, type);
      // 対象の値を変更
      array[index].value = converted_value;
      return array;
    });
  };

  /**
   * 項目のフォーカスアウト時の処理（日付項目のみ対象）
   *
   * @param content 画面表示情報
   * @param value 値
   */
  const handleBlurForDate = (content: Content, value: Date | null) => {
    const target_value =
      value !== null && content.value !== ''
        ? Moment(content.value).format('YYYY-MM-DD')
        : content.value;
    // 入力値変換
    const convert_data = convertInputData(content.fm_id, target_value, content.input_assistance);
    // バリデーションチェック
    validationCheck(content.fm_id, convert_data, content.fm_type).then((res) => {
      // validである、かつfuncがnullでもundefinedでも0文字でもなければAPIをキックする
      if (
        res &&
        content.function !== null &&
        typeof content.function !== 'undefined' &&
        content.function.length > 0
      ) {
        const post_data: PostData = {
          detail: [
            {
              id: content.fm_id,
              value: convert_data,
              name: content.field_column_name,
            },
          ],
          module_name: content.default_value,
          reception_id: reception_id,
          reception_cd: reception_cd,
          status: status_code,
          is_json: true,
        };
        // postData(post_data, content.pb_id, content.cb_id, false, false);
      }
    });
  };

  /**
   * 項目のフォーカスアウト時の処理（APIコールあり）
   * FIXME sakuma:所属している棚の全入力値をPOSTする不具合アリ。要修正
   *
   * @param id 項目ID
   * @param value 項目の入力値
   * @param type 項目の変換タイプ
   * @param is_send_parent post対象の指定
   * @param func コールするファンクション
   * @param pb_id 親棚のid
   * @param cb_id 子棚のid
   */
  const handleBlurCallApi = (
    id: number,
    value: string,
    type: string,
    is_send_parent: boolean,
    func: string,
    pb_id: number,
    cb_id: number
  ) => {
    // 入力値変換
    const convert_data = convertInputData(id, value, type);

    // バリデーションチェック
    validationCheck(id, convert_data, type).then((res) => {
      // validである、かつfuncがnullでもundefinedでも0文字でもなければAPIをキックする
      if (res && func !== null && typeof func !== 'undefined' && func.length > 0) {
        requestModule(is_send_parent, func, pb_id, cb_id);
      }
    });
  };

  /**
   * チェックボックスの変更値をstateに保存する
   * 対応項目：Checkbox
   *
   * @param changed_value チェックした値
   * @param is_checked 現在のチェック状態
   * @param name 対象のname属性
   * @param velus 現在の値
   */
  const handleChangeCheck = (
    checked_value: string,
    is_checked: boolean,
    fm_id: number,
    values: string[]
  ) => {
    // 値の変更
    if (is_checked) {
      values.push(checked_value);
    } else {
      values = values.filter((value) => value !== checked_value);
    }
    values.sort();
    handleChangeInput(values, fm_id);
  };

  /**
   * 郵便番号の変更値をstateに保存する
   * 対応項目：Postcode
   *
   * @param changed_value 変更した値
   * @param fm_id 対象のid
   * @param values 現在の値
   * @param array_index 対応するindex値
   */
  const handleChangePostCode = (
    changes_value: string,
    fm_id: number,
    values: string[],
    array_index: number
  ) => {
    // 値の変更
    values[array_index] = changes_value;
    handleChangeInput(values, fm_id);
  };

  /**
   * 郵便番号のBlurイベントハンドラ
   * 対応項目：Postcode
   *
   * @param fm_id 対象のid
   * @param values 現在の値fm_id
   * @param input_assistance 入力補助種別
   * @param array_index 対応するindex値
   */
  const handleBlurPostCode = (
    fm_id: number,
    values: string[],
    input_assistance: string,
    array_index: number
  ) => {
    // 入力値変換
    const convert_data = convertData(input_assistance, values[array_index]);
    values[array_index] = convert_data;
    setContents((prev) =>
      prev.map((value) =>
        value.fm_id === fm_id && !value.disabled
          ? {
              ...value,
              value: values,
            }
          : value
      )
    );
    // 両項目に値が入っている場合は結合してバリデーションを行う
    const post_date =
      values[postcode_index.first] && values[postcode_index.last] ? values.join('') : convert_data;
    // バリデーションチェック
    validationCheck(fm_id, post_date, input_assistance);
  };

  /**
   * 検索ボタン押下時処理
   * @param module_name 通信対象モジュール名
   * @param fm_id フィールドマスタのid
   * @param field_column_name 項目名
   * @param value: 郵便番号の配列,
   * @param pb_id: 親棚ID,
   * @param  cb_id: 子棚ID
   * @returns void
   */
  const handleClickSearch = (
    module_name: string,
    fm_id: number,
    field_column_name: string,
    value: Array<string>,
    pb_id: number,
    cb_id: number
  ) => {
    const post_data: PostData = {
      reception_id: reception_id,
      reception_cd: reception_cd,
      module_name: module_name,
      status: status_code,
      is_json: true,
      detail: [
        {
          id: fm_id,
          name: field_column_name,
          value: value.join(''),
        },
      ],
    };
    // postData(post_data, pb_id, cb_id, true);
  };

  /**
   * 送信する値を厳選, 変換する
   * @param is_send_parent post対象の指定
   * @param pb_id 親棚のid
   * @param cb_id 子棚のid
   */
  const convertPostData = () => {
    // 送信データを取得
    return contents
      .filter(
        (content) =>
          !!content.fm_id &&
          (isConfirmMode ? true : !content.disabled) &&
          !!content.field_column_name
      )
      .map((data) => {
        // POSTする値を適切な形に変換する
        const date_types = [fm_types.date, fm_types.business_date, fm_types.after_specified_date];
        // 郵便番号以外を対象にデータ変換
        const convert_data =
          data.fm_type === fm_types.postcode
            ? data.value
            : convertData(data.input_assistance, data.value);
        const post_value: string | number | Date =
          (data.fm_type === fm_types.checkbox || data.fm_type === fm_types.no_label_checkbox) &&
          Array.isArray(convert_data)
            ? convert_data.join()
            : data.fm_type === fm_types.postcode && Array.isArray(convert_data)
            ? convert_data.join('')
            : data.input_assistance === convert_types.add_comma && typeof convert_data === 'string'
            ? convert_data.replace(/,/g, '')
            : date_types.includes(data.fm_type) && convert_data !== null && convert_data !== ''
            ? Moment(convert_data).format('YYYY-MM-DD')
            : convert_data;
        return {
          id: data.fm_id,
          name: data.field_column_name,
          value: post_value,
          fm_type: data?.fm_type,
        };
      });
  };

  /**
   * API呼び出し共通ファンクション
   * @param is_send_parent post対象の指定
   * @param function_name 呼び出しモジュール名
   * @param pb_id 親棚のid
   * @param cb_id 子棚のid
   * @return void
   */
  const requestModule = (
    is_send_parent: boolean,
    func: number | string,
    pb_id: number,
    cb_id: number
  ) => {
    const post_data: PostData = {
      reception_id: reception_id,
      reception_cd: reception_cd,
      status: status_code,
      module_name: func,
      detail: convertPostData(),
      is_json: true,
      branch: branchValue,
      email: emailValue,
    } as PostData;
    // postData(post_data, pb_id, cb_id, true, is_send_parent);
  };

  /**
   * APIに値をPOSTする
   *
   * @param post_data postするデータ
   * @param pb_id 親棚のid
   * @param cb_id 子棚のid
   * @param is_send_parent? post対象の指定
   * @param should_loading ローディング表示用フラグ
   */
  const postData = async (
    post_data: PostData,
    pb_id: number,
    cb_id: number,
    should_loading: boolean,
    is_send_parent?: boolean
  ) => {
    try {
      // 通信中の場合はAPIにリクエストをしない
      if (is_connecting) {
        return;
      }
      setIsConnecting(true); // 通信中フラグを立てる
      setIsLoading(should_loading);
      // APIにデータをPOSTする
      const response = await axios.post('/api/common', post_data);
      // 正常なレスポンス
      if (response.data.result) {
        allocationResponseData(response.data, pb_id, cb_id, is_send_parent, post_data.module_name);
        // 異常なレスポンス
      } else {
        showExceptionDialog(response.data.message);
        setIsLoading(false);
      }
    } catch (error) {
      console.error(error);
      jumpUrl(error.response.data.url);
      setIsLoading(false);
    } finally {
      setIsConnecting(false); // 通信中フラグを倒す
    }
  };

  /**
   * レスポンス結果から画面処理を振り分ける
   *
   * @param reasponse_data API返却値
   * @param pb_id 親棚ID
   * @param cb_id 小棚ID
   * @param is_send_parent post対象の指定
   * @param module_name モジュール名
   */
  const allocationResponseData = (
    reasponse_data: ResponsData,
    pb_id: number,
    cb_id: number,
    is_send_parent: boolean | undefined,
    module_name: string | number
  ) => {
    switch (reasponse_data.response_type) {
      case api_response_type.page_transition: // 画面遷移
        pageTransition(reasponse_data.reception_cd);
        break;
      case api_response_type.dialog: // ダイアログ表示
        showResponseDialog(reasponse_data.detail, pb_id, cb_id);
        break;
      case api_response_type.validation: // バリデーション
        setValidMessage(reasponse_data.detail, pb_id, cb_id, is_send_parent);
        break;
      case api_response_type.list: // リスト
        showSearchResult(reasponse_data.detail);
        break;
      case api_response_type.auto_input: // 指定項目の自動入力
        setDataAutoInput(reasponse_data.detail);
        break;
      case api_response_type.auto_input_all: // 複数項目への自動入力
        setDataAutoInputAll(reasponse_data.detail);
        break;
      case api_response_type.transition_to_list: // 一覧画面に遷移
        transitionToList();
        break;
      case api_response_type.transition_to_mypage: // マイページ開設同意画面への遷移
        transitionToMypage();
        break;
      case api_response_type.download: // pdfダウンロード
        downloadPdf(module_name);
        break;
      //住所検索の条件追加
      default:
        break;
    }
  };

  /**
   * 更新された値を使用し、次の詳細画面を表示します。
   * @param reception_cd 案件コード
   */
  const pageTransition = (reception_cd: string) => {
    setIsLoading(false);
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/receptions/${reception_cd}`;
  };

  /**
   * レスポンスからダイアログを生成する
   * @param response_detail レスポンス値
   * @param pb_id 親棚ID
   * @param cb_id 小棚ID
   */
  const showResponseDialog = (response_detail: DialogRespose, pb_id: number, cb_id: number) => {
    const post_data: PostData = {
      reception_id: reception_id,
      reception_cd: reception_cd,
      status: status_code,
      module_name: 0,
      detail: [],
      is_json: true,
    };
    // 応答結果からボタン押下時のイベントハンドラ作成
    const event_handler = response_detail.btn_function.map((function_name: string) => {
      return function_name !== ''
        ? // APIコール
          () => {
            post_data.module_name = function_name;
            // postData(post_data, pb_id, cb_id, true);
            setResponseDialogState(dialog_init);
          }
        : // モーダルを閉じる
          () => {
            setResponseDialogState(dialog_init);
          };
    });
    // ダイアログの状態を更新
    const dialog_state: DialogState = {
      is_confirm: response_detail.dialog_type === dialog_type.confirm,
      show: true,
      title: response_detail.dialog_title,
      body: editModalBody(response_detail.dialog_message),
      ClickConfirm: event_handler[dialog_function.confirm],
      ClickYes: event_handler[dialog_function.yes],
      ClickNo: event_handler[dialog_function.no],
    };
    setResponseDialogState(dialog_state);
    setIsLoading(false);
  };

  /**
   * バリデーション結果を画面に表示する
   * メッセージが空の場合は次の棚を開く
   *
   * @param detail バリデーション結果
   * @param pb_id 親棚のid
   * @param cb_id 小棚のid
   * @param is_send_parent post対象の指定
   */
  const setValidMessage = (
    details: Array<FormResponse>,
    pb_id: number,
    cb_id: number,
    is_send_parent: boolean | undefined
  ) => {
    if (details.length === 0) {
      // 現在の棚に属する項目のメッセージを初期化する
      setContents((prev) =>
        prev.map((value) =>
          value.pb_id === pb_id && value.cb_id === cb_id
            ? {
                ...value,
                message: undefined, // メッセージを初期化する
              }
            : value
        )
      );
      // 現在の棚を閉じる
      toggleChildShelf(pb_id, cb_id, false);
      const next_cb_id = findNextChidShelf(cb_id);
      if (next_cb_id !== 0) {
        // 次の棚を開く
        toggleChildShelf(pb_id, next_cb_id, true);
        // 次の棚へスクロールする
        scrollToNextShelf(pb_id, cb_id);
      }
      setIsLoading(false);
      return;
    }

    for (const detail of details) {
      // バリデーション項目のindex取得
      const content_index = contents.findIndex(
        (content) =>
          content.field_column_name === detail.form_name &&
          content.disabled === false &&
          content.pb_id
      );
      // バリデーション項目を持つ子棚を開く
      if (contents[content_index]?.cb_id)
        toggleChildShelf(pb_id, contents[content_index].cb_id, true);
    }

    setContents((prev) =>
      prev.map((value) => {
        // 同じカラム名 & 活性項目のバリデーションメッセージを表示
        let tmp_value: Content = tmp_init;
        for (const detail of details) {
          if (is_send_parent) {
            // 親棚単位の場合、全体のメッセージを更新する
            if (value.field_column_name === detail.form_name && !value.disabled) {
              tmp_value = {
                ...value,
                message: detail.message,
              };
              break;
            } else {
              tmp_value = {
                ...value,
                message: undefined, // メッセージを初期化する
              };
            }
          } else {
            // 子棚単位の場合、対象の棚に限定してメッセージを更新する
            if (value.pb_id === pb_id && value.cb_id === cb_id) {
              if (value.field_column_name === detail.form_name && !value.disabled) {
                tmp_value = {
                  ...value,
                  message: detail.message,
                };
                break;
              } else {
                tmp_value = {
                  ...value,
                  message: undefined, // メッセージを初期化する
                };
              }
            } else {
              tmp_value = value;
            }
          }
        }
        return tmp_value;
      })
    );

    // バリデーション項目にフォーカスイン
    const index = contents.findIndex(
      (value) => !value.disabled && value.field_column_name === details[0].form_name
    );
    if (index >= 0) {
      // 郵便番号、チェックボックス、ラジオは対象idに文字列を付与
      const target_id = [fm_types.checkbox, fm_types.postcode, fm_types.radio].includes(
        contents[index].fm_type
      )
        ? `${contents[index].key}${valid_merge_index}`
        : contents[index].key;
      const target_element = document.getElementById(target_id);
      // 対象elementに合わせて座標移動
      scrollTargetElement(target_element, scroll_option.validation);
      target_element?.focus();
    }
    setIsLoading(false);
  };

  /**
   * 検索結果を画面に表示する
   * 件数0：モーダルのみ表示
   * 件数1：自動入力 + モーダル表示
   * 件数2：選択式モーダル表示
   * @param {Array<SearchResult>} details 検索結果
   */
  const showSearchResult = (details: Array<SearchResult>) => {
    const dialog_state = {
      title: address_option.title,
      body: '',
      details: details,
      is_confirm: true,
      show: true,
    };
    if (details.length <= 0) {
      dialog_state.body = address_option.undefined_body;
    } else if (details.length > 0 && details.length <= 1) {
      // 自動入力
      setContents((prev) => {
        const target_index = prev.findIndex(
          (value) => value.field_column_name === details[0].form_name && !value.disabled
        );
        const array = prev.slice(); // ディープコピー
        array[target_index].value = details[0].value;
        return array;
      });
      const current_index = contents.findIndex(
        (value) => value.field_column_name === details[0].form_name && !value.disabled
      );
      dialog_state.body = `${contents[current_index].fm_display_name}${address_option.auto_input_body}`;
    } else {
      dialog_state.is_confirm = false;
    }
    setSearchDialogState(dialog_state);
    setIsLoading(false);
  };

  /**
   * 検索項目つきテキストボックスコンポーネントのを画面に表示する
   * 選択式モーダル表示
   * @param {Array<SearchResult>} details 検索結果
   */
  const showTextWithSearchItem = (detail: Array<KeyValue>, field_column_name: string) => {
    const detail_shift = detail.filter((val) => val.value !== '');
    // 選択解除のための空欄項目を追加
    detail_shift.unshift({ key: '', value: '' });
    const dialog_state = {
      title: text_with_search_option.title,
      body: '',
      details: detail_shift,
      is_confirm: false,
      show: true,
      field_column_name: field_column_name,
    };
    setTextWithSearchDialogState(dialog_state);
    setIsLoading(false);
  };

  /**
   * 選択されているアドレスを画面に表示する
   */
  const setSelectAddress = useCallback(() => {
    if (address_state.form_name === '') {
      return;
    }
    setContents((prev) => {
      const target_index = prev.findIndex(
        (value) => value.field_column_name === address_state.form_name && !value.disabled
      );
      const array = prev.slice(); // ディープコピー
      array[target_index].value = address_state.value;
      return array;
    });
    setSearchDialogState(search_dialog_init);
    setAddressState({ form_name: '', value: '' });
  }, [address_state]);

  /**
   * 検索項目つきテキストボックスで選択されている項目を画面に表示する
   */
  const setTextWithSearchItem = useCallback(() => {
    setContents((prev) => {
      const target_index = prev.findIndex(
        (value) => value.field_column_name === text_with_search_state.name && !value.disabled
      );
      const array = prev.slice(); // ディープコピー
      array[target_index].value = text_with_search_state.value;
      return array;
    });
    setTextWithSearchDialogState(text_with_search_dialog_init);
    setTextWithSearchState({ name: '', value: '' });
  }, [text_with_search_state]);

  /**
   * 住所の選択状態を変更
   * @param event イベント
   */
  const handleChangeAddress = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setAddressState({
        form_name: event.target.name,
        value: event.target.value,
      });
    },
    [address_state]
  );

  /**
   * 検索項目つきテキストボックスの選択状態を変更
   * @param event イベント
   */
  const handleChangeTextWithSearchItem = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      setTextWithSearchState({
        name: event.target.name,
        value: event.target.value,
      });
    },
    [text_with_search_state]
  );

  /**
   * 住所検索情報を初期化
   */
  const clearAddressInfo = useCallback(() => {
    setAddressState(address_init);
    setSearchDialogState(search_dialog_init);
    setTextWithSearchDialogState(text_with_search_dialog_init);
  }, []);

  /**
   * 対応する案件一覧に遷移する
   */
  const transitionToList = () => {
    is_staff
      ? location.replace(`${process.env.MIX_MOCK_URL}/staff/list${location.search}`)
      : location.replace(`${process.env.MIX_MOCK_URL}/mypage/list`);
    setTimeout(() => setIsLoading(false), loding_close_timmer);
  };

  /**
   * 対応するマイページ開設同意確認画面に遷移する
   */
  const transitionToMypage = async () => {
    try {
      const response = await axios.post('agreement/store', {
        reception_cd: reception_cd,
        reception_id: reception_id,
      });
      location.href = response.data.url;
    } catch (error) {
      console.log(error);
    } finally {
      setTimeout(() => setIsLoading(false), loding_close_timmer);
    }
  };

  /**
   * pdfをダウンロードする
   * @param module_name 通信対象モジュール名
   * @return void
   */
  const downloadPdf = async (module_name: string | number) => {
    const post_data: PostData = {
      module_name: module_name,
      reception_cd: reception_cd,
      reception_id: reception_id,
      status: status_code,
      is_json: false,
      detail: [],
    };
    try {
      const start_time = performance.now(); // 開始時間
      setIsLoading(true);
      const response = await axios.post('/api/common', post_data, {
        responseType: 'blob',
      });
      // ファイルダウンロード
      if (response.headers['content-type'] === content_type.pdf) {
        //IOS端末かつsafariの場合、ブラウザバック禁止処理を解除してダウンロードしたファイルを表示後に元画面に戻れるようにする。
        if (isBrowserIOSSafari() || isBrowserIpadSafari()) {
          releaseBrowzerBack();
        }

        fileDownload(response.data, response.headers['content-disposition'], content_type.pdf);
      } else {
        // pdf以外許容しないため、ダイアログ表示
        showExceptionDialog('システムエラーが発生しました');
      }
      // ローディング停止を遅らせる
      const end_time = performance.now(); // 終了時間
      setTimeout(() => {
        setIsLoading(false);
      }, download_wait_time - (end_time - start_time));
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  /**
   * エラー発生時、ダイアログを表示する
   *
   * @param message ダイアログ表示メッセージ
   */
  const showExceptionDialog = (message: string) => {
    // ダイアログの状態を更新
    const dialog_state: DialogState = {
      is_confirm: true,
      show: true,
      title: '',
      body: editModalBody(message),
      ClickConfirm: () => {
        setResponseDialogState(dialog_init);
      },
    };
    setResponseDialogState(dialog_state);
  };

  /**
   * 該当の項目に対し、バリデーションチェックを実施し、結果を画面に表示する
   * @param id バリデーション対象項目ID
   * @param value バリデーション対象項目入力値
   * @param type 変換タイプ
   * @return boolean バリデーション結果
   */
  const validationCheck = async (id: number, value: string, type: string) => {
    // 入力値がnullの場合、空文字に変換
    if (value === null) {
      value = '';
    }

    if (type === convert_types.add_comma) {
      value = value.replace(/,/g, ''); // カンマ除去
    }

    try {
      const response = await axios.get(`/api/check`, { params: { id, value } });
      // バリデーションエラーなし
      setContents((prev) =>
        prev.map((value) =>
          value.fm_id === id && !value.disabled
            ? {
                ...value,
                message: undefined, // メッセージを初期化する
              }
            : value
        )
      );
      return true;
    } catch (error) {
      // バリデーションエラーあり
      if (error.response.data.statusCode === 422) {
        setContents((prev) =>
          prev.map((value) =>
            value.fm_id === id && !value.disabled
              ? {
                  ...value,
                  message: error.response.data.message, // 画面にエラーメッセージを表示する
                }
              : value
          )
        );
      } else {
        console.log(error.response.data.message); // コンソールにエラーメッセージを表示する
      }
      return false;
    }
  };

  /**
   * 該当の項目に対し、文字変換を実施する
   * @param id 文字変換対象項目ID
   * @param value 変換する文字
   * @param type 変換タイプ
   */
  const convertInputData = (id: number, value: string, type: string): string => {
    const convert_data = convertData(type, value);
    setContents((prev) =>
      prev.map((value) =>
        value.fm_id === id && !value.disabled
          ? {
              ...value,
              value: convert_data,
            }
          : value
      )
    );
    return convert_data;
  };

  /**
   * 入力履歴ボタンを押下する
   */
  const clickReceptionHistory = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.preventDefault();
    window.open(
      `${location.origin}${process.env.MIX_MOCK_URL}/staff/history/${reception_cd}`,
      '_blank',
      'top=0,left=0,left=0,width=600,height=600,resizable=yes'
    );
  };

  /**
   * セレクトボックスが変更されたらAPIにリクエストする
   */
  const handleChangeSelected = (event: React.ChangeEvent<HTMLInputElement>, content: Content) => {
    // functionが設定されてない場合は処理をしない
    if (
      content.function === null ||
      typeof content.function === 'undefined' ||
      content.function.length === 0
    ) {
      return;
    }

    const message_cd = event.target.value;
    // バリデーションチェック
    validationCheck(content.fm_id, event.target.value, content.input_assistance).then((res) => {
      // バリデーションを正常通過した場合はAPIをコールする
      if (res) {
        const post_data: PostData = {
          detail: [],
          module_name: content.default_value,
          reception_id: reception_id,
          reception_cd: reception_cd,
          type_cd: reception_sub_cd,
          message_cd: message_cd,
          status: status_code,
          is_json: true,
        };
        // postData(post_data, content.pb_id, content.cb_id, false);
      }
    });
  };

  /**
   * 指定項目に自動入力する
   * @param detail APIレスポンス
   */
  const setDataAutoInput = (detail: AutoInput) => {
    setContents((prev) => {
      const current_index = prev.findIndex(
        (value) => value.field_column_name === detail.form_name && !value.disabled
      );
      const array = prev.slice(); // ディープコピー
      array[current_index].value = detail.value;
      return array;
    });
    setIsLoading(false);
  };

  /**
   * 画面全体に対して、指定項目に自動入力する
   * @param details APIレスポンス
   */
  const setDataAutoInputAll = (details: Array<SearchResult>) => {
    setContents((prev) =>
      prev.map((current_value) => {
        // 同じカラム名 & 活性項目の値を変更
        let tmp_value: Content = tmp_init;
        for (const detail of details) {
          if (current_value.field_column_name === detail.form_name && !current_value.disabled) {
            tmp_value = {
              ...current_value,
              value: detail.value,
            };
            break;
          } else {
            tmp_value = current_value;
          }
        }
        return tmp_value;
      })
    );
    setIsLoading(false);
  };

  const setAllValidMessage = (details?: FormResponse[]) => {
    const newContents = contents?.reduce<Content[]>((prev, curr) => {
      const currErrorMessage =
        details?.find((detail) => detail?.form_name === curr?.field_column_name)?.message ??
        undefined;
      return [...prev, { ...curr, message: currErrorMessage }];
    }, []);
    const contentsErrored = newContents?.filter((content) => content.message);

    // set unValid filed
    setContents(newContents);

    // set valid mes file upload list
    const newFileUploadList = file_upload_list?.reduce<FileUpload[]>((prev, curr) => {
      const currFieldColumnName = contents?.find(
        (content) => content?.fm_id === curr?.fm_id
      )?.field_column_name;

      const errorKey = `${currFieldColumnName}.${curr.name}`;
      const currValidMessage = details?.find((detail) => detail?.form_name === errorKey)?.message;

      return [
        ...prev,
        { ...curr, valid_messages: currValidMessage ? { file: currValidMessage } : {} },
      ];
    }, []);
    setFileUploadList(newFileUploadList);

    // open unValid parent shelf
    setParentShelfs((prevState) =>
      prevState.map((parentShelf) => {
        const isCurrShelfError = contentsErrored?.find(
          (content) => content.pb_id === parentShelf.pb_id
        );
        return { ...parentShelf, pb_open: isCurrShelfError ? true : parentShelf?.pb_open };
      })
    );

    // open unValid child shelf
    setChildShelfs((prevState) =>
      prevState.map((childShelf) => {
        const isCurrShelfError = contentsErrored?.some(
          (content) => content.cb_id === childShelf.cb_id
        );
        return { ...childShelf, cb_open: isCurrShelfError ? true : childShelf?.cb_open };
      })
    );

    // scroll to unValid
    const errorField = document.getElementById(contentsErrored?.[0]?.key);
    scrollTargetElement(errorField, scroll_option.validation);
    errorField?.focus();
  };

  const saveConfirmData = async (customContents?: Content[], customFiles?: FileUpload[]) => {
    const activeContents = customContents ?? contents;
    const activeFilesList = customFiles || file_upload_list;

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const files = activeFilesList.map(({ file, preview_file_src, ...rest }) => rest);
    const currentTabId = getTabId();

    const confirmData = {
      template_id: getKeyFormUrl(),
      tab_id: currentTabId,
      detail: convertPostData(),
      branch: branchValue,
      email: emailValue,
      info: {
        ...(resDataTemplate?.info ?? {}),
        contents: activeContents?.map((content) => ({ ...content, message: undefined })),
        files: files,
      },
      template: resDataTemplate?.template,
    };

    const response = await axios.post(`/api/receptions/confirm`, confirmData);
    return response;
  };

  const handleClickConfirm = async () => {
    try {
      setIsClickConfirm(true);
      setIsLoading(true);
      const response = await saveConfirmData();
      if (response?.data?.success) {
        location.href = `${location.origin}${
          process.env.MIX_MOCK_URL
        }/receptions-confirm/${getKeyFormUrl()}`;
      }
    } catch (error) {
      const errorData = error?.response?.data;

      setAllValidMessage(errorData?.detail);

      if (errorData?.error_code === 'SESSION_EXPIRED') {
        handleTemporaryFilesCleanup();
        alert(errorData?.message);
        location.reload();
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleClickSubmit = async (otp?: string) => {
    try {
      setIsLoading(true);
      const files = file_upload_list.map(({ file, preview_file_src, ...rest }) => rest);

      const currentTabId = getTabId();

      const submitData = {
        template_id: getKeyFormUrl(),
        tab_id: currentTabId,
        template: resDataTemplate?.template,
        detail: convertPostData(),
        branch: branchValue,
        email: emailValue,
        otp: Number(otp),
        files: files,
      };
      const response = await axios.post(`/api/receptions/store`, submitData);
      location.href = `${location.origin}${
        process.env.MIX_MOCK_URL
      }/receptions-completed/${getKeyFormUrl()}/${response?.data?.data?.reception_cd}`;
    } catch (error) {
      const errorData = error?.response?.data;

      alert(errorData?.message);

      if (errorData?.error_code === 'SESSION_EXPIRED') {
        handleTemporaryFilesCleanup();
        location.replace(
          `${location.origin}${process.env.MIX_MOCK_URL}/receptions/${getKeyFormUrl()}`
        );
      }
      return errorData?.message;
    } finally {
      setIsLoading(false);
    }
  };

  const handleClickRequestOTP = async () => {
    try {
      setIsLoading(true);
      await axios.post(`/send-otp`, { email: emailValue, tab_id: getTabId() });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <UserInfoSubmitReception contents={contents} setContents={setContents} />

      {contents.length !== 0 && createParentBlock()}
      <ResponseDialog
        is_confirm={response_dialog_state.is_confirm}
        show={response_dialog_state.show}
        title={response_dialog_state.title}
        body={response_dialog_state.body}
        ClickCallBackYes={response_dialog_state.ClickYes}
        ClickCallBackNo={response_dialog_state.ClickNo}
        ClickCallBackConfirm={response_dialog_state.ClickConfirm}
      />
      <SearchResultDialog
        details={search_dialog_state.details}
        is_confirm={search_dialog_state.is_confirm}
        show={search_dialog_state.show}
        title={search_dialog_state.title}
        body={search_dialog_state.body}
        ClickCallBackYes={setSelectAddress}
        ClickCallBackNo={clearAddressInfo}
        ClickCallBackConfirm={clearAddressInfo}
        handleChange={handleChangeAddress}
      />
      <TextWithSearchDialog
        is_confirm={text_with_search_dialog_state.is_confirm}
        details={text_with_search_dialog_state.details}
        show={text_with_search_dialog_state.show}
        title={text_with_search_dialog_state.title}
        handleChange={handleChangeTextWithSearchItem}
        ClickCallBackYes={setTextWithSearchItem}
        ClickCallBackNo={clearAddressInfo}
        field_column_name={text_with_search_dialog_state.field_column_name}
      />
      {/* ローディング画面 */}
      <LoadingModal show={is_loading} />
      {/* 固定表示ボタン */}
      {is_staff && <FloatingMenu is_staff={is_staff} is_on_change={is_on_change} />}

      <ReceptionActions
        isConfirmMode={isConfirmMode}
        isNeedToVerifyOTP={!resDataTemplate?.user_info?.tenant_id}
        onClickConfirm={handleClickConfirm}
        onClickSubmit={handleClickSubmit}
        onClickRequestOTP={handleClickRequestOTP}
        onClickBack={() =>
          (location.href = `${location.origin}${
            process.env.MIX_MOCK_URL
          }/receptions/${getKeyFormUrl()}`)
        }
      />
    </>
  );
};

const div = document.getElementById('main');
if (div) {
  //Receptionコンポーネント専用のIE対応用クラスを付与する。
  div.classList.add(isBrowserIe() ? 'ie' : 'no-ie');
}

const container = document.getElementById('template');
if (container) {
  const root = createRoot(container);
  root.render(<Reception />);
}
